import { TRANSACTION_STATUS } from './operation'

export const transactionStatusBadge = {
  [TRANSACTION_STATUS.PLACED]: {
    label: 'Payment Processing',
    textColor: '#D4792F',
    bgColor: 'rgba(212, 121, 47, 0.08)',
  },
  [TRANSACTION_STATUS.PROCESSING]: {
    label: 'Payment Processing',
    textColor: '#D4792F',
    bgColor: 'rgba(212, 121, 47, 0.08)',
  },
  [TRANSACTION_STATUS.SUCCESS]: {
    label: 'Paid',
    textColor: '#25B883',
    bgColor: 'rgba(37, 184, 131, 0.1)',
  },
  [TRANSACTION_STATUS.ERROR]: {
    label: 'Failed',
    textColor: '#F25A68',
    bgColor: 'rgba(242, 90, 104, 0.08)',
  },
  [TRANSACTION_STATUS.CANCELED]: {
    label: 'Cancelled',
    textColor: '#F25A68',
    bgColor: 'rgba(242, 90, 104, 0.08)',
  },
  [TRANSACTION_STATUS.SCHEDULED]: {
    label: 'Payment Processing',
    textColor: '#D4792F',
    bgColor: 'rgba(212, 121, 47, 0.08)',
  },
  [TRANSACTION_STATUS.PENDING]: {
    label: 'Payment Processing',
    textColor: '#D4792F',
    bgColor: 'rgba(212, 121, 47, 0.08)',
  },
}
